if (typeof customElements.get("newsletter-story") === 'undefined') {

    class NewsletterStory extends HTMLElement {
        constructor() {
            super();
          this.bottomMessage = this.querySelector(".newsletter-banner__bottom-message p");
          this.emailInput = this.querySelector("input[type='email']")
          if (this.bottomMessage) {
            console.log("Bottom Message found");
            console.log(this.bottomMessage);
            console.log(this.emailInput);
            this.emailInput.addEventListener("focus", this.handleFocus.bind(this));
            this.emailInput.addEventListener("blur", this.handleBlur.bind(this));
          }
        }

        connectedCallback() {
                  
        }

      handleFocus() {
        console.log("Focus");
        if (!this.bottomMessage.classList.contains("show")) {
          this.bottomMessage.classList.add("show");
        }
      }

      handleBlur() {
        console.log("Blur");
        if (this.bottomMessage.classList.contains("show")) {
          this.bottomMessage.classList.remove("show");
        }
      }

    }

    customElements.define('newsletter-story', NewsletterStory);
}